import { stringToBoolean } from './utils/string'

export const enableBidHistory = stringToBoolean(
  process.env.REACT_APP_FEATURE_FLAG_BID_HISTORY
)

export const enableSideNavigation = stringToBoolean(
  process.env.REACT_APP_FEATURE_FLAG_SIDE_NAVIGATION
)

export const enableChecklistCategories = stringToBoolean(
  process.env.REACT_APP_FEATURE_FLAG_CHECKLIST_CATEGORIES
)

export const enableClientDashboard = stringToBoolean(
  process.env.REACT_APP_FEATURE_FLAG_CLIENT_DASHBOARD
)
